/**
 * Contrato padronizado de erros entre Object APIs GeneXus, BFF e front.
 *
 * Formato: `{ erro: { codigo, mensagem, detalhes?, camposComErro? } }`
 *
 * `codigo` em UPPER_SNAKE_CASE; `mensagem` em PT-BR pronta para exibição.
 */
/** Códigos de erro reconhecidos no contrato. */
export const ErrorCode = {
    /** Payload inválido (Zod, regras de campo, formato). HTTP 400. */
    VALIDACAO: 'VALIDACAO',
    /** Token ausente/inválido. HTTP 401. */
    NAO_AUTENTICADO: 'NAO_AUTENTICADO',
    /** Perfil/permissão insuficiente. HTTP 403. */
    SEM_PERMISSAO: 'SEM_PERMISSAO',
    /** Recurso não existe (ou usuário não pode vê-lo). HTTP 404. */
    NAO_ENCONTRADO: 'NAO_ENCONTRADO',
    /** Conflito de estado (ex.: unicidade, vigência sobreposta). HTTP 409. */
    CONFLITO: 'CONFLITO',
    /** Regra de negócio violada (validação semântica do GeneXus). HTTP 422. */
    REGRA_NEGOCIO: 'REGRA_NEGOCIO',
    /** Access token expirado — front deve tentar refresh. HTTP 401. */
    ACCESS_TOKEN_EXPIRED: 'ACCESS_TOKEN_EXPIRED',
    /** CSRF token ausente ou inválido. HTTP 403. */
    CSRF_INVALIDO: 'CSRF_INVALIDO',
    /** Credenciais inválidas em /auth/token. HTTP 401. */
    CREDENCIAIS_INVALIDAS: 'CREDENCIAIS_INVALIDAS',
    /** Timeout no upstream (GeneXus). HTTP 504. */
    GATEWAY_TIMEOUT: 'GATEWAY_TIMEOUT',
    /** Erro inesperado. HTTP 500. */
    INTERNAL_ERROR: 'INTERNAL_ERROR',
};
/** Helper para localizar a mensagem de um campo específico em `camposComErro`. */
export function findFieldError(errors, campo) {
    return errors?.find((e) => e.campo === campo)?.mensagem;
}
/** Type guard utilitário para distinguir resposta de erro de sucesso. */
export function isErrorEnvelope(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const erro = value.erro;
    if (typeof erro !== 'object' || erro === null)
        return false;
    return typeof erro.codigo === 'string';
}
//# sourceMappingURL=errors.js.map